import type { ApplicationState } from 'redux/reducers';
import { parseCoordinatesToBing } from 'utils/map-utils';

export const coverageQuestionsStateSelector = (state: ApplicationState) =>
  state.mobilityContinuation.coverageQuestions;
export const wasAnswerRemovedSelector = (state: ApplicationState) =>
  coverageQuestionsStateSelector(state).wasAnswerRemoved;
export const hasNextQuestion = (state: ApplicationState) =>
  coverageQuestionsStateSelector(state).data?.nextQuestion !== null;
export const currentQuestionSelector = (state: ApplicationState) =>
  coverageQuestionsStateSelector(state).data?.nextQuestion || undefined;
export const questionTextSelector = (state: ApplicationState) => {
  const data = coverageQuestionsStateSelector(state).data;
  if (!data || !data.nextQuestion) {
    return undefined;
  }
  return data.nextQuestion.metadata[0].value;
};

export const coverageResponsesSelector = (state: ApplicationState) =>
  coverageQuestionsStateSelector(state).data?.coverageResponses || [];

export const coverageSelector = (state: ApplicationState) =>
  coverageQuestionsStateSelector(state).coverage;

/**
 * Policies
 */
export const policiesSelector = (state: ApplicationState) =>
  state.mobilityContinuation.policy;

/**
 * Answers without any filter applied
 */
export const answersSelector = (state: ApplicationState) =>
  coverageQuestionsStateSelector(state).answers;

export const servicesCoveredSelector = (state: ApplicationState) =>
  coverageQuestionsStateSelector(state).coverage;

export const mobilityContinuationSelector = (state: ApplicationState) =>
  state.mobilityContinuation;

export const mobilityContinuationServiceCreated = (state: ApplicationState) =>
  mobilityContinuationSelector(state).service!;

export const mobilityContinuationStartSelector = (state: ApplicationState) =>
  mobilityContinuationSelector(state).start;

export const mobilityContinuationStartDataSelector = (
  state: ApplicationState,
) => {
  const data = mobilityContinuationStartSelector(state);
  return {
    loading: data.loading,
    queryResult: data.queryResult,
    temporalSelected: data.temporalSelected,
  };
};
export const mobilityContinuationDestinationSelector = (
  state: ApplicationState,
) => mobilityContinuationSelector(state).destination;

export const mobilityContinuationDestinationDataSelector = (
  state: ApplicationState,
) => {
  const data = mobilityContinuationDestinationSelector(state);
  return {
    loading: data.loading,
    queryResult: data.queryResult,
    temporalSelected: data.temporalSelected,
  };
};

/**
 * Create body for createQuestion API request
 */
export const MCSelectedLocationSelector = (state: ApplicationState) => {
  const origin = mobilityContinuationStartSelector(state).temporalSelected;

  const destination =
    mobilityContinuationDestinationSelector(state).temporalSelected;
  if (origin && destination) {
    return {
      origin: {
        address: origin.address,
        coordinates: parseCoordinatesToBing(origin.coordinates),
      },
      destination: {
        address: origin.address,
        coordinates: parseCoordinatesToBing(destination.coordinates),
      },
    };
  }
  return { origin, destination };
};

/**
 * Create body for getDistanceForMobility request
 */
export const mobilityContinuationSelectedTemporalCoordsSelector = (
  state: ApplicationState,
) => {
  const origin =
    mobilityContinuationStartSelector(state).temporalSelected?.coordinates;

  const destination =
    mobilityContinuationDestinationSelector(state).temporalSelected
      ?.coordinates;

  if (origin && destination) {
    return {
      origin: parseCoordinatesToBing(origin),
      destination: parseCoordinatesToBing(destination),
    };
  }
  return { origin, destination };
};

export const mobilityContinuationConsentSelector = (state: ApplicationState) =>
  mobilityContinuationSelector(state).consent;

export const mobilityContinuationProductIdSelector = (
  state: ApplicationState,
) => mobilityContinuationSelector(state).productId;
